import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["lang"];
import React, { forwardRef } from 'react';
import { I18nProvider } from '../i18n/I18nProvider';
import { Box, FullWidthContainer, JukeboxProvider, AddOn } from '@xceedsrl/jukebox';
import styled from 'styled-components';
var HeaderText = styled('div').withConfig({
  displayName: "AddOnsForm__HeaderText",
  componentId: "sc-1tcl87b-0"
})(["&&&{fonst-size:16px;line-height:1.5;font-weight:900;color:", ";margin-bottom:", ";}"], function (props) {
  return props.color;
}, function (props) {
  return props.marginBottom;
});
var BottomText = styled('div').withConfig({
  displayName: "AddOnsForm__BottomText",
  componentId: "sc-1tcl87b-1"
})(["&&&{fonst-size:16px;line-height:1.5;line-height:1.71;font-weight:900;color:", ";margin-top:", ";}"], function (props) {
  return props.color;
}, function (props) {
  return props.marginTop;
});
var Form = forwardRef(function (_ref, ref) {
  var addOns = _ref.addOns,
    ticketQuantity = _ref.ticketQuantity,
    setAddOnsSelected = _ref.setAddOnsSelected,
    addOnsSelected = _ref.addOnsSelected,
    isBottleService = _ref.isBottleService,
    i18n = _ref.i18n,
    customTitleColor = _ref.customTitleColor,
    lang = _ref.lang,
    isRequired = _ref.isRequired,
    isMultipleChoice = _ref.isMultipleChoice;
  var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  var singleSelectionMode = function singleSelectionMode(_ref2) {
    var id = _ref2.id,
      isChecked = _ref2.isChecked,
      price = _ref2.price,
      name = _ref2.name;
    if (!isChecked && !isRequired) {
      setAddOnsSelected([]);
      return;
    }
    var newState = {
      id: id,
      quantity: ticketQuantity,
      name: name,
      price: price
    };
    setAddOnsSelected([newState]);
  };
  var multipleSelectionMode = function multipleSelectionMode(_ref3) {
    var id = _ref3.id,
      isChecked = _ref3.isChecked,
      price = _ref3.price,
      name = _ref3.name;
    if (isChecked) {
      setAddOnsSelected([].concat(addOnsSelected, [{
        id: id,
        quantity: ticketQuantity,
        name: name,
        price: price
      }]));
    } else {
      setAddOnsSelected(addOnsSelected.filter(function (addon) {
        return addon.id !== id;
      }));
    }
  };
  var handleClick = function handleClick(_ref4) {
    var id = _ref4.id,
      isChecked = _ref4.isChecked,
      price = _ref4.price,
      name = _ref4.name;
    if (isMultipleChoice) {
      multipleSelectionMode({
        id: id,
        isChecked: isChecked,
        price: price,
        name: name
      });
    } else {
      singleSelectionMode({
        id: id,
        isChecked: isChecked,
        price: price,
        name: name
      });
    }
  };
  var formatPrice = function formatPrice(value, currency, locale) {
    return value.toLocaleString(locale, {
      style: 'currency',
      localeMatcher: 'best fit',
      currency: currency || 'EUR'
    });
  };
  var checkIsSelected = function checkIsSelected(addOn) {
    var isSelectedChecked = !!addOnsSelected && addOnsSelected.some(function (addOnSelected) {
      return addOnSelected.id === addOn.id;
    });
    return isSelectedChecked;
  };
  return React.createElement(JukeboxProvider, null, React.createElement(FullWidthContainer, {
    id: "xceed-dropin-container"
  }, i18n.headerText && React.createElement(HeaderText, {
    color: customTitleColor,
    marginBottom: isMobile ? '17px' : '30px'
  }, isMultipleChoice ? i18n.headerText : i18n.headerTextSingle, ' ', isRequired ? '*' : i18n.optional), addOns.map(function (addOn) {
    return ((addOn === null || addOn === void 0 ? void 0 : addOn.availableItems) === null || (addOn === null || addOn === void 0 ? void 0 : addOn.availableItems) >= ticketQuantity) && React.createElement(Box, {
      mb: '24px',
      key: addOn.id
    }, React.createElement(AddOn, _extends({}, addOn, {
      "data-testid": "addon-card",
      price: addOn.fixedPrice.amount,
      formatedPrice: formatPrice(addOn.fixedPrice.amount, addOn.fixedPrice.currency, lang),
      i18n: i18n,
      onClick: handleClick,
      isSelected: checkIsSelected(addOn),
      isBottleService: isBottleService,
      isCheckbox: isMultipleChoice
    })));
  }), i18n.bottomText && !isRequired && React.createElement(BottomText, {
    color: customTitleColor,
    marginTop: isMobile ? '0px' : '45px'
  }, i18n.bottomText)));
});
var AddOnsForm = forwardRef(function (_ref5, ref) {
  var lang = _ref5.lang,
    props = _objectWithoutPropertiesLoose(_ref5, _excluded);
  return React.createElement(I18nProvider, {
    lang: lang
  }, React.createElement(Form, _extends({}, props, {
    lang: lang,
    ref: ref
  })));
});
export default React.memo(AddOnsForm);
Form.defaultProps = {
  i18n: {
    headerText: '',
    headerTextSingle: '',
    optional: '',
    bottomText: ''
  },
  customTitleColor: ''
};
AddOnsForm.defaultProps = {
  customTitleColor: ''
};
Form.displayName = 'Form';